// ABOUTME: Maintenance mode full-screen page
// ABOUTME: Displayed when server is unavailable, follows Monument visual identity

import { useTranslation } from "react-i18next";

import { HyperText } from "@/shared/ui/kit/hyper-text";
import { Particles } from "@/shared/ui/kit/particles";
import Logo from "@/shared/ui/logo";

import { MaintenanceBackground } from "./maintenance-background";
import { MaintenanceIcon } from "./maintenance-icon";

export function MaintenancePage() {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background">
      {/* Background layer */}
      <MaintenanceBackground />

      {/* Particles */}
      <Particles
        className="absolute inset-0"
        quantity={40}
        color="#7f67ff"
        staticity={50}
        ease={50}
        size={0.4}
      />

      {/* Logo - top left */}
      <div className="absolute left-6 top-6 z-20 scale-110 sm:left-8 sm:top-8">
        <Logo />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-1 flex-col items-center justify-center gap-4 px-6 sm:gap-5">
        {/* Icon */}
        <MaintenanceIcon />

        {/* Title */}
        <HyperText
          as="h1"
          className="font-display text-2xl font-semibold tracking-tight text-foreground sm:text-3xl lg:text-4xl"
          duration={1200}
          startOnView
        >
          {t("maintenance.title")}
        </HyperText>

        {/* Description */}
        <p className="max-w-md text-center text-sm text-muted-foreground sm:text-base">
          {t("maintenance.description")}
        </p>

        {/* Auto-restore notice */}
        <div className="mt-2 flex items-center gap-2 text-xs text-muted-foreground">
          <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-green-500" />
          {t("maintenance.autoRestore")}
        </div>
      </div>

      {/* Footer */}
      <div className="relative z-10 pb-6">
        <p className="text-xs text-muted-foreground">
          {t("maintenance.footer")}
        </p>
      </div>
    </div>
  );
}
